/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NumberOfPagesWidgetQueryVariables = GraphQL.Exact<{
  endDate: GraphQL.Scalars['DateYMD']['input'];
  scope: GraphQL.Scalars['String']['input'];
  startDate: GraphQL.Scalars['DateYMD']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type NumberOfPagesWidgetQuery = { readonly __typename?: 'Query', readonly dashboardData: { readonly __typename?: 'DashboardData', readonly numberOfPages: { readonly __typename?: 'WebsiteDashboardNumberOfPages', readonly id: CK.ID, readonly pollInterval: number | null, readonly reasonForNoData: GraphQL.WebsiteDashboardReasonForNoData | null, readonly data: { readonly __typename?: 'WebsiteDashboardNumberOfPagesData', readonly deltaFromStartDate: number | null, readonly numberOfPagesOnEndDate: number } | null } } };


export const NumberOfPagesWidgetDocument = gql`
    query NumberOfPagesWidget($endDate: DateYMD!, $scope: String!, $startDate: DateYMD!, $websiteId: WebsiteId!) {
  dashboardData {
    numberOfPages(
      endDate: $endDate
      scope: $scope
      startDate: $startDate
      websiteId: $websiteId
    ) {
      data {
        deltaFromStartDate
        numberOfPagesOnEndDate
      }
      id
      pollInterval
      reasonForNoData
    }
  }
}
    `;

/**
 * __useNumberOfPagesWidgetQuery__
 *
 * To run a query within a React component, call `useNumberOfPagesWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberOfPagesWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberOfPagesWidgetQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      scope: // value for 'scope'
 *      startDate: // value for 'startDate'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useNumberOfPagesWidgetQuery(baseOptions: Apollo.QueryHookOptions<NumberOfPagesWidgetQuery, NumberOfPagesWidgetQueryVariables> & ({ variables: NumberOfPagesWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NumberOfPagesWidgetQuery, NumberOfPagesWidgetQueryVariables>(NumberOfPagesWidgetDocument, options);
      }
export function useNumberOfPagesWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NumberOfPagesWidgetQuery, NumberOfPagesWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NumberOfPagesWidgetQuery, NumberOfPagesWidgetQueryVariables>(NumberOfPagesWidgetDocument, options);
        }
export function useNumberOfPagesWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NumberOfPagesWidgetQuery, NumberOfPagesWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NumberOfPagesWidgetQuery, NumberOfPagesWidgetQueryVariables>(NumberOfPagesWidgetDocument, options);
        }
export type NumberOfPagesWidgetQueryHookResult = ReturnType<typeof useNumberOfPagesWidgetQuery>;
export type NumberOfPagesWidgetLazyQueryHookResult = ReturnType<typeof useNumberOfPagesWidgetLazyQuery>;
export type NumberOfPagesWidgetSuspenseQueryHookResult = ReturnType<typeof useNumberOfPagesWidgetSuspenseQuery>;
export type NumberOfPagesWidgetQueryResult = Apollo.QueryResult<NumberOfPagesWidgetQuery, NumberOfPagesWidgetQueryVariables>;